import Users from './UsersPage';

export default Users;
